module.exports = __webpack_public_path__ + "static/media/55_000016.ac3e7e94.jpg";